module.exports = __webpack_public_path__ + "static/img/facilities-text-2.4cf20a71.png";